"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfLeagueTeamsSduiGroupDto = instanceOfLeagueTeamsSduiGroupDto;
exports.LeagueTeamsSduiGroupDtoFromJSON = LeagueTeamsSduiGroupDtoFromJSON;
exports.LeagueTeamsSduiGroupDtoFromJSONTyped = LeagueTeamsSduiGroupDtoFromJSONTyped;
exports.LeagueTeamsSduiGroupDtoToJSON = LeagueTeamsSduiGroupDtoToJSON;
exports.LeagueTeamsSduiGroupDtoToJSONTyped = LeagueTeamsSduiGroupDtoToJSONTyped;
var DigestStepConfigDto_1 = require("./DigestStepConfigDto");
/**
 * Check if a given object implements the LeagueTeamsSduiGroupDto interface.
 */
function instanceOfLeagueTeamsSduiGroupDto(value) {
    if (!('leagueCode' in value) || value['leagueCode'] === undefined)
        return false;
    if (!('step' in value) || value['step'] === undefined)
        return false;
    return true;
}
function LeagueTeamsSduiGroupDtoFromJSON(json) {
    return LeagueTeamsSduiGroupDtoFromJSONTyped(json, false);
}
function LeagueTeamsSduiGroupDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'leagueCode': json['leagueCode'],
        'step': (0, DigestStepConfigDto_1.DigestStepConfigDtoFromJSON)(json['step']),
    };
}
function LeagueTeamsSduiGroupDtoToJSON(json) {
    return LeagueTeamsSduiGroupDtoToJSONTyped(json, false);
}
function LeagueTeamsSduiGroupDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'leagueCode': value['leagueCode'],
        'step': (0, DigestStepConfigDto_1.DigestStepConfigDtoToJSON)(value['step']),
    };
}
